import type { PondOverview } from '@/types/api';

export type StatusColor = 'green' | 'amber' | 'red' | 'gray';

export function getPondStatus(pond: PondOverview): StatusColor {
  if (pond.status !== 'active') return 'gray';
  const alertCount = pond.alert_count ?? 0;
  if (alertCount > 0) return 'red';
  if (pond.active_cycle?.latest_reading?.has_alert) return 'amber';
  return 'green';
}
